import { render, staticRenderFns } from "./AreaFlavorView.vue?vue&type=template&id=7f48f536&scoped=true"
import script from "./AreaFlavorView.vue?vue&type=script&lang=js"
export * from "./AreaFlavorView.vue?vue&type=script&lang=js"
import style0 from "./AreaFlavorView.vue?vue&type=style&index=0&id=7f48f536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48f536",
  null
  
)

export default component.exports